import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Users from './components/pages/Users';
import About from './components/pages/About';
import Touches from './components/pages/Touches';
import Clients from './components/pages/Clients';
import PrivateRoute from './components/routing/PrivateRoute';
import 'bootstrap/dist/css/bootstrap.min.css';

import AuthState from './context/auth/AuthState';
import UserState from './context/user/UserState';
import ClientsState from './context/clients/ClientState';
import SubscriptionsState from './context/subscriptions/SubscriptionsState';
import AlertState from './context/alert/AlertState';
import TouchesState from './context/touches/TouchesState';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import Alerts from './components/layout/Alerts';
import setAuthToken from './utils/setAuthToken';

import './App.css';

if (localStorage.token) {
  setAuthToken(localStorage.getItem('token'));
}

const App = () => {
  return (
    <AuthState>
      <UserState>
        <ClientsState>
          <SubscriptionsState>
            <AlertState>
              <TouchesState>
                <Router>
                  <Fragment>
                    <Navbar />
                    <div className='container'>
                      <Alerts />
                      <Switch>
                        <PrivateRoute exact path='/' component={Users} />
                        <PrivateRoute exact path='/about' component={About} />
                        <PrivateRoute
                          exact
                          path='/clients'
                          component={Clients}
                        />
                        <PrivateRoute
                          exact
                          path='/touches'
                          component={Touches}
                        />
                        <PrivateRoute
                          exact
                          path='/register'
                          component={Register}
                        />
                        <Route exact path='/login' component={Login} />
                      </Switch>
                    </div>
                  </Fragment>
                </Router>
              </TouchesState>
            </AlertState>
          </SubscriptionsState>
        </ClientsState>
      </UserState>
    </AuthState>
  );
};

export default App;
